import { BaseModel } from './base.model';
import { IconDefinition, faFile, faFileWord, faFilePdf, faFilePowerpoint, faFileExcel, faFileImage, faFileAlt } from '@fortawesome/pro-light-svg-icons';
import { MorphModel } from './morph.model';

export class ResourceModel extends BaseModel {

  // columns
  hashed_id: string;
  owner: MorphModel;
  extension: string;
  type: string;
  public_name: string; // tslint:disable-line: variable-name
  permissions: Array<string> = [];
  misc: any;

  get icon(): IconDefinition {
    switch (this.extension) {
      case ('pdf'): {
        return faFilePdf;
      }
      case ('txt'):
      case ('rtf'): {
        return faFileAlt;
      }
      case ('doc'):
      case ('docx'): {
        return faFileWord;
      }
      case ('gif'):
      case ('jpg'):
      case ('jpeg'):
      case ('svg'):
      case ('webp'):
      case ('bmp'):
      case ('png'): {
        return faFileImage;
      }
      case ('xls'):
      case ('xlsx'): {
        return faFileExcel;
      }
      case ('ppt'):
      case ('pptx'): {
        return faFilePowerpoint;
      }
      default: {
        return faFile;
      }
    }
  }

  get filesize(): string {
    let bytes: number = parseInt(this.misc?.filesize, 10);
    const sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB']
    if (bytes === 0) return 'n/a'
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    if (i === 0) return `${bytes} ${sizes[i]})`
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
  }

  hasRight(userType: string): boolean {
    return (
      userType === 'moderator' ||
      (userType === 'candidate' && this.permissions?.indexOf('candidate') !== -1) ||
      (userType === 'observer' && this.permissions?.indexOf('observer') !== -1)
    );
  }

}
